import React, { useEffect, useState } from "react";
import { Switch, Tooltip } from "@mui/material";

const SwitchButton = ({
  checked,
  initialEnabled,
  onToggle,
  tooltipText = "",
  disabled = false,
}) => {
  const isControlled = checked !== undefined;
  const [uncontrolled, setUncontrolled] = useState(Boolean(initialEnabled));

  useEffect(() => {
    if (!isControlled) {
      setUncontrolled(Boolean(initialEnabled));
    }
  }, [initialEnabled, isControlled]);

  const enabled = isControlled ? Boolean(checked) : uncontrolled;

  const handleToggle = (event) => {
    const newState = event.target.checked;
    if (!isControlled) setUncontrolled(newState);
    onToggle?.(newState);
  };

  return (
    <Tooltip title={tooltipText}>
      <span>
        <Switch
          checked={enabled}
          onChange={handleToggle}
          disabled={disabled}
          color={enabled ? "primary" : "default"}
        />
      </span>
    </Tooltip>
  );
};

export default SwitchButton;
